<div style="display: flex; flex-direction: row; margin-top: 5em">
  <div style="flex: 1 1 auto">&nbsp;</div>
  <div
    style="width: 40%; margin: auto; display: flex; flex-direction: row; justify-content: center; font-family: sans-serif">
    <div class="material-icons {{css_class}}" style="font-size: 96px">{{icon}}</div>
    <div style="margin-left: 1em; display: flex; justify-content: center; flex-direction: column;">
      <span *ngIf="code != '0'" style="font-size: xx-large; font-weight: bold">{{code}}</span>
      <span *ngIf="code == '0'" style="font-size: xx-large; font-weight: bold">Tilkoblingsfeil</span>
      <span style="margin-top: 0.5em; font-size: large">{{description}}</span>
    </div>
  </div>
  <div style="flex: 1 1 auto">&nbsp;</div>
</div>
